export default __webpack_public_path__ + "static/media/condemnation.704e824a.png";